export const MuiTabs = (palette) => ({
  root: {},
  scroller: {
    borderBottom: `1px solid ${palette.primary.light}`,
  },
  indicator: {
    backgroundColor: palette.primary.main,
  },
})

export const MuiTab = (palette) => ({
  root: {
    'fontSize': '16px !important',
    'fontWeight': 900,
    '&$selected': {
      color: palette.primary.main,
    },
  },
})
